import { observable } from 'mobx';
import BaseModalStore from '@src/components/modal-container/base-modal-store';
import { noop } from '@src/utils/common-util';

class MoModalVeteranReviewCreateTeamStore extends BaseModalStore {
  @observable closeCallback = noop;

  constructor(options = {}) {
    super(options);
    Object.assign(this, options);
  }

  use() {
    super.use();
  }
}

export default MoModalVeteranReviewCreateTeamStore;
